import React from 'react'
import styled from 'styled-components'
import { skills } from '../../data/constants'

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  position: relative;
  z-index: 1;
  align-items: center;
  background: rgba(30, 30, 60, 0.45);
  box-shadow: 0 8px 32px 0 rgba(31, 38, 135, 0.18);
  backdrop-filter: blur(8px);
  border-radius: 32px;
  padding: 40px 0;
`

const Wrapper = styled.div`
position: relative;
display: flex;
justify-content: space-between;
align-items: center;
flex-direction: column;
width: 100%;
max-width: 1100px;
gap: 12px;
@media (max-width: 960px) {
    flex-direction: column;
}
`

export const Title = styled.div`
font-size: 42px;
text-align: center;
font-weight: 600;
margin-top: 20px;
  color: ${({ theme }) => theme.text_primary};
  @media (max-width: 768px) {
margin-top: 12px;
      font-size: 32px;
  }
`;

export const Desc = styled.div`
    font-size: 18px;
    text-align: center;
    max-width: 600px;
    color: ${({ theme }) => theme.text_secondary};
    @media (max-width: 768px) {
        font-size: 16px;
    }
`;

const SkillsContainer = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  margin-top: 30px;
  gap: 30px;
  justify-content: center;
`

const Skill = styled.div`
  width: 100%;
  max-width: 500px;
  background: linear-gradient(120deg, ${({ theme }) => theme.card} 80%, ${({ theme }) => theme.primary + '22'} 100%);
  border: 1.5px solid ${({ theme }) => theme.primary + '55'};
  box-shadow: 0 4px 32px ${({ theme }) => theme.primary + '22'};
  border-radius: 20px;
  padding: 24px 40px;
  transition: transform 0.2s, box-shadow 0.2s;
  position: relative;
  overflow: hidden;
  &:hover {
    transform: scale(1.03) translateY(-4px);
    box-shadow: 0 8px 48px ${({ theme }) => theme.primary + '44'};
    border-color: ${({ theme }) => theme.primary};
  }
  @media (max-width: 768px) {
    max-width: 400px;
    padding: 16px 24px;
  }
  @media (max-width: 500px) {
    max-width: 330px;
    padding: 10px 16px;
  }
`

const SkillTitle = styled.h2`
  font-size: 30px;
  font-weight: 700;
  color: ${({ theme }) => theme.primary};
  margin-bottom: 20px;
  text-align: center;
  background: linear-gradient(90deg, ${({ theme }) => theme.primary}, ${({ theme }) => theme.text_primary});
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  text-fill-color: transparent;
`

const SkillList = styled.div`
  display: flex;
  justify-content: center; 
  flex-wrap: wrap;
  gap: 12px;
  margin-bottom: 20px;
`

const SkillItem = styled.div`
  font-size: 16px;
  font-weight: 500;
  color: ${({ theme }) => theme.text_primary};
  border: 1.5px solid ${({ theme }) => theme.primary + '55'};
  border-radius: 12px;
  padding: 12px 18px;
  background: ${({ theme }) => theme.card_light};
  box-shadow: 0 2px 12px ${({ theme }) => theme.primary + '11'};
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  transition: box-shadow 0.2s, transform 0.2s;
  &:hover {
    box-shadow: 0 4px 24px ${({ theme }) => theme.primary + '33'};
    transform: scale(1.07);
    border-color: ${({ theme }) => theme.primary};
  }
  @media (max-width: 768px) {
    font-size: 14px;
    padding: 8px 12px;
  }
  @media (max-width: 500px) {
    font-size: 14px;
    padding: 6px 12px;
  }
`

const SkillImage = styled.img`
  width: 28px;
  height: 28px;
  filter: drop-shadow(0 0 6px ${({ theme }) => theme.primary + '44'});
`


const Skills = () => {
  return (
    <Container id="skills">
      <Wrapper>
        <Title>Skills</Title>
        <Desc>Here are some of my skills on which I have been working on for the past 2 years.
        </Desc>
        <SkillsContainer>
          {skills.map((skill) => (
            <Skill key={skill.title}>
              <SkillTitle>{skill.title}</SkillTitle>
              <SkillList>
                {skill.skills.map((item) => (
                  <SkillItem key={item.name}>
                    <SkillImage src={item.image} alt={item.name} />
                    {item.name}
                  </SkillItem>
                ))}
              </SkillList>
            </Skill>
          ))}
        </SkillsContainer>
      </Wrapper>
    </Container>
  )
}

export default Skills